export default "__VITE_ASSET__06300789__"